import { ICoreContext } from '@msdyn365-commerce/core-internal';
import React from 'react';
import { useIsMobile } from '../hooks/useIsMobile';

export type PropsWithIsMobile<T> = T & { isMobile?: boolean };

export const withIsMobile = <P extends { context: ICoreContext }>(Wrapped: React.ComponentType<PropsWithIsMobile<P>>) => {
    return (props: P) => {
        const isMobile = useIsMobile(props.context);
        return <Wrapped {...props} isMobile={isMobile} />;
    };
};
